import React, {Component} from "react";
import $ from "jquery";

import * as Const from "../../const/Const";

import * as CommonUtils from "../../utils/CommonUtils";
import * as ModalUtils from "../../utils/ModalUtils";

import favIconPng from "../../../resources/icon/png/mutanoidsgame_logo.png";
import logoNameSvg from "../../../resources/icon/svg/common/mutanoidsgame_logo_name.svg";
import logoImageSvg from "../../../resources/icon/svg/common/mutanoidsgame_logo.svg";
import returnSvg from "../../../resources/icon/svg/blue/return.svg";
import playMarketSvg from "../../../resources/icon/svg/common/icon_playmarket.svg";
import huaweiStoreSvg from "../../../resources/icon/svg/common/icon_huawei_app_gallery.svg";
import ruStoreSvg from "../../../resources/icon/svg/common/icon_ru_store.svg";
import amazonAppStoreSvg from "../../../resources/icon/svg/common/icon_amazon_app_store.svg";
import oppoAppMarketSvg from "../../../resources/icon/svg/common/icon_oppo_app_market.svg";
import xiaomiAppStoreSvg from "../../../resources/icon/svg/common/icon_xiaomi_app_store.svg";

export default class MutanoidsGamePage extends Component {

    constructor(props) {
        super(props);

        this.state = {
            previousId: "",
            refreshId:""
        };

        this.updateRandomMutanoidOnPage = this.updateRandomMutanoidOnPage.bind(this);
    }

    componentDidMount() {
        CommonUtils.changePageTitle(CommonUtils.getAppName());
        CommonUtils.changePageFavIcon(favIconPng);

        this.updateRandomMutanoidOnPage().then( () => {} );
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return nextState.refreshId !== this.state.refreshId;
    }

    async updateRandomMutanoidOnPage() {
        let data = {sessionId:"", lang:"en", action:"random_approved_mutanoid_from_user", data: { previousId: this.state.previousId}};
        let responseObj = await CommonUtils.makeAsyncRequestCommon({path:Const.SERVER_URL, type:Const.POST_REQ_TYPE, requestData:data})
        this.setState({previousId: responseObj.id})
        $("#randomFromUserImage").remove();

        let imageSrc = 'data:image/png;base64,' + responseObj.data['fileInBase64'];
        $("#randomMutanoidDiv").append("<img id='randomFromUserImage' class='randomFromUserImage' src='" + imageSrc + "' alt=''/>");

        setTimeout(() => this.updateRandomMutanoidOnPage(), 10000)
    }

    render() {
        return (
            <div className={'mainPageDiv'}>
                <img src={returnSvg} className={'returnButton'} alt=''
                     onClick={ () => {
                         let spinner = ModalUtils.showMutaSpinner();
                         setTimeout(() => { spinner.remove(); CommonUtils.openLinkInCurrentTab('?page=main') }, 1000)
                     }}/>
                <img src={logoNameSvg} className={'mainPageLogoName'} alt=''/>
                <img src={logoImageSvg} className={'standaloneLogoImage'} alt={''}/>

                <iframe className={'standaloneYoutubeVideo'} width={'45%'} height={'40%'} frameBorder={'0'} src="http://www.youtube.com/embed/wzBGHail6vI" allowFullScreen/>

                <div id={'randomMutanoidDiv'} className={'randomMutanoidDiv'}/>

                <div className={'appStoresDiv'}>
                    <img className={'mutanoidsGameChannelsDivItem'} src={ruStoreSvg} alt={''} title={'RuStore'}/>
                    <img className={'mutanoidsGameChannelsDivItem'} style={{marginTop:'10px'}} src={huaweiStoreSvg} alt={''} title={'Huawei App Gallery'}/>
                    <img className={'mutanoidsGameChannelsDivItem'} style={{marginTop:'10px'}} src={playMarketSvg} alt={''} title={'Google Play Market'}/>
                    <img className={'mutanoidsGameChannelsDivItem'} style={{marginTop:'10px'}} src={amazonAppStoreSvg} alt={''} title={'Amazon App Store'}/>
                    <img className={'mutanoidsGameChannelsDivItem'} style={{marginTop:'10px'}} src={oppoAppMarketSvg} alt={''} title={'Oppo App Market'}/>
                    <img className={'mutanoidsGameChannelsDivItem'} style={{marginTop:'10px'}} src={xiaomiAppStoreSvg} alt={''} title={'Xiaomi App Store'}/>
                </div>

                <div className={'privacyPolicyDiv noSelect'}
                     onClick={ () => {
                         let spinner = ModalUtils.showMutaSpinner();
                         setTimeout(() => { spinner.remove(); CommonUtils.openLinkInCurrentTab('?page=privacyPolicy') }, 1000)
                     }}>
                    {'Privacy policy'}
                </div>
                {CommonUtils.getAppVersionNameDiv()}
            </div>
        )
    }
}